import { useState } from "react";
import { ArrowRight, Eye, EyeOff, Loader2, LockKeyhole, UserRound } from "lucide-react";
import { Dialog, DialogContent, DialogDescription, DialogTitle } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";

export const SiteLoginDialog = ({ mode, onClose }) => {
  const patient = mode === "patient";
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [visible, setVisible] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const prefix = `${mode}-login`;
  const Icon = patient ? UserRound : LockKeyhole;
  async function submit(event) {
    event.preventDefault();
    if (busy) return;
    setBusy(true); setError("");
    try {
      // Public-site requests deliberately bypass the ERP's global 401 redirect interceptor.
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/${patient ? "patient-auth" : "auth"}/login`, {
        method: "POST", credentials: "include", headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email: email.trim(), password }),
      });
      const data = await response.json();
      if (!response.ok) {
        const detail = data.detail;
        setError(typeof detail === "string" ? detail : Array.isArray(detail) ? detail.map((d) => d.msg).join(". ") : "Não foi possível entrar. Confira seus dados.");
        setBusy(false); return;
      }
      if (!patient && data.token) window.localStorage.setItem("kloss_token", data.token);
      window.location.assign(patient ? "/area-paciente" : "/consultas-agenda");
    } catch (_) {
      setError("Não foi possível conectar. Tente novamente."); setBusy(false);
    }
  }
  return <Dialog open onOpenChange={(open) => { if (!open && !busy) onClose(); }}><DialogContent className="site-login-dialog" data-testid={`${prefix}-dialog`} closeButtonTestId={`${prefix}-close`}>
    <img src="/brand/kloss-stacked-dark.webp" className="site-login-logo" alt="Kloss Experience" data-testid={`${prefix}-logo`} />
    <div className="site-login-heading"><Icon size={21} strokeWidth={1.4} /><DialogTitle data-testid={`${prefix}-title`}>{patient ? "Área do paciente" : "Painel de controle"}</DialogTitle></div>
    <DialogDescription className="sr-only">{patient ? "Acesso do paciente com e-mail e senha cadastrados" : "Acesso da equipe com e-mail e senha"}</DialogDescription>
    <form onSubmit={submit} className="site-login-form" data-testid={`${prefix}-form`}>
      <label htmlFor={`${prefix}-email`}>E-mail<Input id={`${prefix}-email`} data-testid={`${prefix}-email`} type="email" required autoComplete="username" value={email} disabled={busy} onChange={(e) => { setEmail(e.target.value); setError(""); }} /></label>
      <label htmlFor={`${prefix}-password`}>Senha<div className="site-login-password"><Input id={`${prefix}-password`} data-testid={`${prefix}-password`} type={visible ? "text" : "password"} required autoComplete="current-password" value={password} disabled={busy} onChange={(e) => { setPassword(e.target.value); setError(""); }} /><button type="button" onClick={() => setVisible((v) => !v)} disabled={busy} data-testid={`${prefix}-password-toggle`} aria-label={visible ? "Ocultar senha" : "Mostrar senha"} title={visible ? "Ocultar senha" : "Mostrar senha"}>{visible ? <EyeOff size={18} /> : <Eye size={18} />}</button></div></label>
      {error && <p role="alert" className="site-login-error" data-testid={`${prefix}-error`}>{error}</p>}
      <a href={patient ? "/area-paciente/esqueci-senha" : "/esqueci-senha"} data-testid={`${prefix}-forgot`} className="site-login-forgot">Esqueci minha senha</a>
      <button type="submit" className="site-button site-login-submit" disabled={busy} data-testid={`${prefix}-submit`}>{busy ? <><Loader2 size={17} className="animate-spin" /> Entrando…</> : <>Entrar <ArrowRight size={17} /></>}</button>
    </form>
  </DialogContent></Dialog>;
};